import { useState, forwardRef, useImperativeHandle, useContext, useEffect } from 'react';
import { Row, Col, Input, message } from 'antd';
import PSAIModal from '@PSAIComponents/PSAIModal';
import styles from './index.module.scss';
import { AppContext } from '@utils/AppContext';
import API from '@api/api.js';
import eventBus from '@utils/eventBus';
import Iconfont from '@utils/Iconfont';
import Utils from '@utils/utils'

const JoinTeam = forwardRef((props, ref) => {
    useImperativeHandle(ref, () => ({
        setJoinVisible
    }));
    const [joinVisible, setJoinVisible] = useState(false)
    const [tipsVisible, setTipsVisible] = useState(false)
    const [nickName, setNickName] = useState('')
    const [orgId, setOrgId] = useState('')
    const [key, setKey] = useState('')

    const joinTeamClick = async () => {
        if (!nickName) {
            message.warning('请输入您的昵称');
            return;
        }
        if (!orgId || !key) {
            message.warning('请重新打开邀请链接！');
            return;
        }
        API.postJoinOrg({
            orgId,
            key,
            nickName,
        }).then((res) => {
            if (res.code == 0) {
                if (Utils.isMobileDevice()) {
                    // 移除URL上的查询参数并刷新页面
                    const url = new URL(window.location.href);
                    url.search = '';
                    window.history.replaceState({}, document.title, url.toString());
                    setTipsVisible(true)
                } else {
                    setJoinVisible(false)
                    message.success('加入企业成功，即将进入企业账号！')
                    setTimeout(() => {
                        postChangeOrg(orgId)
                    }, 1000)
                }
            } else {
                message.error(res.message)
            }
        })
    }

    const postChangeOrg = (id) => {
        API.postChangeOrg({
            orgId: id
        }).then((res) => {
            if (res.code == 0) {
                // 移除URL上的查询参数并刷新页面
                const url = new URL(window.location.href);
                url.search = '';
                window.history.replaceState({}, document.title, url.toString());
                window.location.reload();
            }
        })
    }

    useEffect(() => {
        if (!joinVisible) return
        const url = new URL(window.location.href)
        const orgId = url.searchParams.get('orgId')
        const key = url.searchParams.get('key')
        setOrgId(orgId)
        setKey(key)
    }, [joinVisible])



    return (
        <>
            <PSAIModal
                title='加入企业'
                maxWidth={400}
                okText={'加入企业'}
                open={joinVisible}
                maskClosable={false}
                okButtonProps={{ disabled: false, loading: false, style: { width: '100%', margin: '0' } }}
                onCancel={() => setJoinVisible(false)}
                onOk={() => joinTeamClick()}
                zIndex={1000}
                cancelButtonProps={{ style: { display: 'none' } }}
            >
                <div className={styles.JoinTeam}>
                    <Input
                        prefix={<Iconfont className={styles.Icon} type="icon-reuseOutlined" />}
                        suffix={`${nickName.length}/20`}
                        placeholder='请输入您的昵称'
                        className={styles.input}
                        maxLength={20}
                        value={nickName}
                        onChange={(e) => setNickName(e.target.value)} />
                </div>
            </PSAIModal>
            <PSAIModal
                title={null}
                maxWidth={320}
                okText={'我知道了'}
                open={tipsVisible}
                maskClosable={false}
                okButtonProps={{ disabled: false, loading: false, style: { width: '80%', margin: '0' } }}
                onCancel={() => { setTipsVisible(false); setJoinVisible(false) }}
                onOk={() => { setTipsVisible(false); setJoinVisible(false) }}
                cancelButtonProps={{ style: { display: 'none' } }}
                zIndex={1002}
            >
                <div className={styles.editNameContent}>
                    <Iconfont style={{ color: '#34C759', fontSize: '50px' }} type="icon-general_correct" />
                    <p>您已加入企业</p>
                    <p>请到网页端进行更多操作</p>
                </div>
            </PSAIModal>
        </>

    );
});

export default JoinTeam;